module.exports = __webpack_public_path__ + "static/media/cog-dark-on-orange-bg.1f39582e.png";